/**
 * send-password-reset-email-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../../general/reply-message";
import { ResponseCode } from "../../general/response-code";
import { MessageTag } from "../../message-tag";

/**
 * A client transmits a {@link SendPasswordResetEmailRequest} when it wishes to
 * reset a user's password. The server reacts by sending an email to the address
 * on record for the user (which is the same as the user's login identifier).
 * This email contains a token that should be sent via a {@link
 * BeginPasswordResetRequest} from a new client connection.
 */
export class SendPasswordResetEmailRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SEND_PASSWORD_RESET_EMAIL;
	public static tag : MessageTag = MessageTag.REQ_SEND_PASSWORD_RESET_EMAIL;

  public verifyReply (reply : Message) : boolean
  {
    return (Message.isA(reply, MessageTag.DOWN_DISCONNECT)
      && reply.code === ResponseCode.OK);
  }

  /**
   * Construct a new {@link SendPasswordResetEmailRequest}.
   */
  constructor (public login : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/send-password-reset-email-request.ts